<template>
<div v-if="!isMobile">
   <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>
 <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">

  <v-card class="mx-auto elevation-19">
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="airQuality"
      :search="search"
    >
    <template v-slot:[`item.timestamp`]="{ item }">
      {{ formatDate(item.timestamp) }}
    </template>
     <template v-slot:[`item.age`]="{ item }">
      <span v-if='item.age == "Close"' style="color:red">{{item.age}}</span>
      <span v-if='item.age == "Open"' style="color:green">{{item.age}}</span>
    </template>
      <template v-slot:[`item.name`]="{ item }">
      <span v-if='item.name == "Close"' style="color:red">{{item.name}}</span>
      <span v-if='item.name == "Open"' style="color:green">{{item.name}}</span>
    </template>
    <template v-slot:[`item.co2`]="{ item }">
     {{item.co2}} ppm
    </template>
    <template v-slot:[`item.humid`]="{ item }">
     {{item.humid}} %RH
    </template>
    <template v-slot:[`item.location`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">Server Room 2</span>
     <span v-if="item.location[0].location == 'Cheng Room'">Server Room 1</span>
     <span v-if="item.location[0].location == 'Production'">Server Room 5</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'">Server Room 4</span>
     <span v-if="item.location[0].location == 'JM Room'">Server Room 3</span>
    </template>
  <template v-slot:[`item.name`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'" style="color:green">Open</span>
     <span v-if="item.location[0].location == 'Cheng Room'" style="color:green">Open</span>
     <span v-if="item.location[0].location == 'Production'" style="color:green">Open</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'" style="color:red">Close</span>
     <span v-if="item.location[0].location == 'JM Room'" style="color:red">Close</span>
    </template>
    <template v-slot:[`item.age`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'" style="color:red">Close</span>
     <span v-if="item.location[0].location == 'Cheng Room'" style="color:red">Close</span>
     <span v-if="item.location[0].location == 'Production'" style="color:green">Open</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'" style="color:green">Open</span>
     <span v-if="item.location[0].location == 'JM Room'" style="color:green">Open</span>
    </template>
    <template v-slot:[`item.temp`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">23.74 °C</span>
     <span v-if="item.location[0].location == 'Cheng Room'">22.13 °C</span>
     <span v-if="item.location[0].location == 'Production'">21.23 °C</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'">21.23 °C</span>
     <span v-if="item.location[0].location == 'JM Room'">21.23 °C</span>
    </template>
      <template v-slot:[`item.timestamp`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'Cheng Room'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'Production'">{{formatDate(new Date())}}</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'JM Room'">{{formatDate(item.timestamp)}}</span>
    </template>
</v-data-table>
  </v-card>

   
  </v-col>
</v-row>
 </v-container>
</div>

<div v-else>
  <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">

  <v-card class="mx-auto elevation-19">
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="airQuality"
      :search="search"
    >
    <template v-slot:[`item.timestamp`]="{ item }">
      {{ formatDate(item.timestamp) }}
    </template>
     <template v-slot:[`item.age`]="{ item }">
      <span v-if='item.age == "Close"' style="color:red">{{item.age}}</span>
      <span v-if='item.age == "Open"' style="color:green">{{item.age}}</span>
    </template>
      <template v-slot:[`item.name`]="{ item }">
      <span v-if='item.name == "Close"' style="color:red">{{item.name}}</span>
      <span v-if='item.name == "Open"' style="color:green">{{item.name}}</span>
    </template>
    <template v-slot:[`item.co2`]="{ item }">
     {{item.co2}} ppm
    </template>
    <template v-slot:[`item.humid`]="{ item }">
     {{item.humid}} %RH
    </template>
    <template v-slot:[`item.location`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">Server Room 2</span>
     <span v-if="item.location[0].location == 'Cheng Room'">Server Room 1</span>
     <span v-if="item.location[0].location == 'Production'">Server Room 5</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'">Server Room 4</span>
     <span v-if="item.location[0].location == 'JM Room'">Server Room 3</span>
    </template>
  <template v-slot:[`item.name`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'" style="color:green">Open</span>
     <span v-if="item.location[0].location == 'Cheng Room'" style="color:green">Open</span>
     <span v-if="item.location[0].location == 'Production'" style="color:green">Open</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'" style="color:red">Close</span>
     <span v-if="item.location[0].location == 'JM Room'" style="color:red">Close</span>
    </template>
    <template v-slot:[`item.age`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'" style="color:red">Close</span>
     <span v-if="item.location[0].location == 'Cheng Room'" style="color:red">Close</span>
     <span v-if="item.location[0].location == 'Production'" style="color:green">Open</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'" style="color:green">Open</span>
     <span v-if="item.location[0].location == 'JM Room'" style="color:green">Open</span>
    </template>
    <template v-slot:[`item.temp`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">23.74 °C</span>
     <span v-if="item.location[0].location == 'Cheng Room'">22.13 °C</span>
     <span v-if="item.location[0].location == 'Production'">21.23 °C</span>
     <span v-if="item.location[0].location == 'Ground Floor Office'">21.23 °C</span>
     <span v-if="item.location[0].location == 'JM Room'">21.23 °C</span>
    </template>
     <template v-slot:[`item.timestamp`]="{ item }">
     <span v-if="item.location[0].location == 'RnD Room'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'Cheng Room'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'Production'">{{formatDate(new Date())}}</span>
    <span v-if="item.location[0].location == 'Ground Floor Office'">{{formatDate(new Date())}}</span>
     <span v-if="item.location[0].location == 'JM Room'">{{formatDate(item.timestamp)}}</span>
    </template>
</v-data-table>
  </v-card>

   
  </v-col>
</v-row>
 </v-container>
</div>

</template>


<script>
import axios from "axios";
import moment from 'moment';

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Security Door',
          disabled: true,
          href: '',
        },
      ],
      values1: moment().subtract(13, "day").startOf("day"),
      values2: moment().subtract(7, "day").endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment().endOf("day")],
        },
        {
          label: "Last Week",
          range: [moment().subtract(13, "day").startOf("day"), moment().subtract(7, "day").endOf("day")],
        },
        {
          label: "This Month",
          range: [moment().startOf("month").startOf("day"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month").startOf("day"), moment().subtract(1, "month").endOf("day")],
        },
      ],
      headers: [
          {
            text: 'Location',
            align: 'start',
            value: 'location',
          },
          { text: 'Main Entrance', value: 'name' },
          { text: 'Side Entrance', value: 'age' },
          { text: 'CO2 Level', value: 'co2' },
          { text: 'Ambient Temperature', value: 'temp' },
          { text: 'Humidity', value: 'humid' },
          { text: 'Date', value: 'timestamp' },
        ],
    loading: true,
    search: '',
    isMobile: true,
    airQuality:[],
    tab: null,
  }),
  mounted() {
    this.loadsCO2();
    this.onResize();
    this.intervalFetchData();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
  intervalFetchData: function () {
    setInterval(() => {    
      this.loadsCo2(),this.loadsWeather()
       }, 300000); 
  },
  onResize() {
      this.isMobile = window.innerWidth < 700;
  },
  formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsCO2: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/air-quality/" + "door" + "/" + this.values1.toDate() + '/'+ this.values2.toDate();
  axios.get(apiURL).then(res => {
    this.airQuality = res.data;
  }).catch(error => {
    console.log(error)
  }).finally(() => this.loading = false);
  },

 updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsCO2();
      this.loading = true;
    },

  updateBoard(){
      this.loadsCO2();
      this.loading = true;
    },

  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

}
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>